
import { EpimsBaseEntityDto } from './epim-base.dto';
export class LessorStakeholderDto extends EpimsBaseEntityDto {
  LessorStakeholderId: string;
  LandTitleId: string;
  AddressBookId: string;
  LessorsId: string;
}
